export type SpotNewsStatus = "draft" | "published";

export interface SpotNews {
  id: string;
  title: string;
  titleAr?: string;
  titleZgh?: string;
  content: string;
  contentAr?: string;
  contentZgh?: string;
  imageUrl?: string;
  linkUrl?: string;
  status: SpotNewsStatus;
  createdAt: string;
  updatedAt: string;
}

export interface SpotNewsConfig {
  isVisible: boolean;
  bannerTitle: string;
  bannerTitleAr?: string;
  bannerTitleZgh?: string;
  speed: number;
}

import { getApiUrl } from "@/utils/apiConfig";

const API_URL = getApiUrl();

export const getSpotNewsData = async (): Promise<{ news: SpotNews[], config: SpotNewsConfig }> => {
  try {
    const res = await fetch(`${API_URL}/spot_news.php?t=${Date.now()}`, {
      headers: {
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache'
      }
    });
    if (!res.ok) throw new Error("Erreur réseau");
    const data = await res.json();
    
    return {
      news: data.news.map((n: any) => ({
        id: n.id,
        title: n.title,
        titleAr: n.title_ar,
        titleZgh: n.title_zgh,
        content: n.content,
        contentAr: n.content_ar,
        contentZgh: n.content_zgh,
        imageUrl: n.image_url,
        linkUrl: n.link_url,
        status: n.status,
        createdAt: n.created_at,
        updatedAt: n.updated_at
      })),
      config: {
        isVisible: data.config.isVisible,
        speed: data.config.speed || 60,
        bannerTitle: data.config.bannerTitle || "Skip pas!",
        bannerTitleAr: data.config.bannerTitleAr || "ماتنساش",
        bannerTitleZgh: data.config.bannerTitleZgh || "ⵓⵔ ⵜⵜⵓ"
      }
    };
  } catch (error) {
    console.error("API indisponible pour Spot News", error);
    return {
      news: [],
      config: { isVisible: true, bannerTitle: "Skip pas!", bannerTitleAr: "ماتنساش", bannerTitleZgh: "ⵓⵔ ⵜⵜⵓ", speed: 60 }
    };
  }
};

export const addSpotNews = async (news: Omit<SpotNews, "id" | "createdAt" | "updatedAt">) => {
  try {
    await fetch(`${API_URL}/spot_news.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ action: 'add', ...news })
    });
  } catch (e) {
    console.error("Erreur addSpotNews", e);
  }
  if (typeof window !== "undefined") window.dispatchEvent(new Event("kaynin_spot_news_updated"));
};

export const updateSpotNews = async (id: string, updates: Partial<SpotNews>) => {
  try {
    await fetch(`${API_URL}/spot_news.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ action: 'update', id, ...updates })
    });
  } catch (e) {
    console.error("Erreur updateSpotNews", e);
  }
  if (typeof window !== "undefined") window.dispatchEvent(new Event("kaynin_spot_news_updated"));
};

export const deleteSpotNews = async (id: string) => {
  try {
    await fetch(`${API_URL}/spot_news.php`, { 
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ action: 'delete', id })
    });
  } catch (e) {
    console.error("Erreur deleteSpotNews", e);
  }
  if (typeof window !== "undefined") window.dispatchEvent(new Event("kaynin_spot_news_updated"));
};

export const saveSpotNewsConfig = async (config: SpotNewsConfig) => {
  try {
    await fetch(`${API_URL}/spot_news.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ action: 'config', config })
    });
  } catch (e) {
    console.error("Erreur saveSpotNewsConfig", e);
  }
  if (typeof window !== "undefined") window.dispatchEvent(new Event("kaynin_spot_news_updated"));
};
